import React from "react";

export const CancelBtn = ({actionText, onClick }) => (
  <button
    className="w-1/3 h-16 mt-4 rounded-md text-2xl text-black bg-white "
    onClick={onClick}
  >
    {actionText}
  </button>
);
